<template>
   <div>
      <div class="vx-row">
         <div class="vx-col w-full">
            <vs-table stripe :data="allDataNegotiations.data" noDataText="No hay datos disponibles">
               <div slot="header" class="mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
                  <div class="pager">
                     <div class="flex flex-wrap">
                        <vs-select @input="pager" v-model.lazy="numberSearchPage" name="numberSearchPage">
                           <vs-select-item :key="index + 1" :value="index + 1" :text="index + 1"
                              v-for="(value, index) in allDataNegotiations.last_page" class="w-full" />
                        </vs-select>
                     </div>
                  </div>
                  <div class="p-3 flex items-center justify-between font-medium">
                     <vs-button v-if="userCanSaveNegotiation" color="success" class="ml-2" size="small"
                        icon-pack="feather" type="filled" @click="popupActivo = true" icon="icon-plus">Nueva
                        Negociación</vs-button>
                  </div>
               </div>
               <template slot="thead">
                  <vs-th>Fecha</vs-th>
                  <vs-th>Negociación</vs-th>
                  <vs-th>Detalles</vs-th>
                  <vs-th>Negociado por</vs-th>
                  <vs-th>Jira</vs-th>
               </template>
               <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                     <vs-td>{{ regularDateFormat(tr.created_at) }}</vs-td>
                     <vs-td>
                        {{ negotiationTypeStr(tr.negotiation_type) }}
                     </vs-td>
                     <vs-td>
                        <template
                           v-if="tr.negotiation_type == 'meses_de_gracia' || tr.negotiation_type == 'solo_intereses'">
                           <span class="bold">Duración:</span> {{ tr.negotiation_data.months }} meses
                           <br>
                        </template>
                        <template v-else-if="tr.negotiation_type == 'reestructura'">
                           <span class="bold">Tasa:</span> {{
                              decimalPercentFormat(tr.negotiation_data.new_annual_interest_percentage) }}<br>
                           <span class="bold">Día de corte:</span> {{ tr.negotiation_data.new_cut_day }}<br>
                           <span class="bold">Plazo:</span> {{ tr.negotiation_data.new_term }} meses<br>
                        </template>
                        <span class="bold">Fecha de inicio:</span> {{regularDateFormat(tr.negotiation_data.start_date) }}
                        <template v-if="tr.negotiation_type == 'puesta_al_corriente' && tr.negotiation_data.discount_negotiation_concepts">
                           <br>
                           <vs-button color="success" type="filled" size="small" icon-pack="feather"
                           icon="icon-dollar-sign" @click="showDiscountNegotiationDetails(tr)">Ver descuentos</vs-button>
                        </template>
                        <template v-else-if="tr.negotiation_type == 'quita'">
                           <template v-if="tr.negotiation_data.discount_negotiation_concepts">
                              <br>
                              <vs-button color="dark" type="filled" size="small" icon-pack="feather"
                              icon="icon-dollar-sign" @click="showDiscountNegotiationDetails(tr)">Ver descuentos</vs-button>
                           </template>
                           <template v-else>
                              <br>
                              <span class="bold">Amortización:</span> {{ explicitMoneyFormat(tr.negotiation_data.amortization) }}<br>
                              <span class="bold">Intereses sin IVA:</span> {{ explicitMoneyFormat(tr.negotiation_data.interest) }}<br>
                           </template>
                        </template>
                     </vs-td>
                     <vs-td>{{ tr.creator_name }}</vs-td>
                     <vs-td>
                        <vs-button v-if="tr.jira_link" color="dark" type="filled" size="small" icon-pack="feather"
                           icon="icon-external-link" :href="tr.jira_link" target="_blank">Visitar</vs-button>
                        <span v-else>--</span>
                     </vs-td>
                  </vs-tr>
               </template>
            </vs-table>
            <div class="mt-3 flex flex-grow justify-end">
               <!-- ITEMS PER PAGE -->
               <div class="p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg font-small">
                  <span>{{ from }} - {{ to }} de {{ totalRecords }}</span>
               </div>
            </div>
         </div>
      </div>
      <!-- MODAL NUEVA NEGOCIACION -->
      <vs-popup class="mid-popup header-primary new-negotiation-popup" title="Nueva negociación"
         :active.sync="popupActivo">
         <div class="vx-row">
            <div class="vx-col w-full">
               <div class="vx-col w-full mb-4">
                  <label class="bold">Tipo:</label>
                  <vs-select class="w-full" v-model.lazy="negotiationType" name="negotiationType"
                     placeholder="Seleccione una opción" v-validate="requiredRules"
                     :danger="hasError('negotiationType')" :danger-text="errorText('negotiationType')"
                     :success="isSuccess('negotiationType')">
                     <vs-select-item :key="index" :value="item.value" :text="item.text"
                        v-for="(item, index) in negotiationOptions" class="w-full" />
                  </vs-select>
               </div>

               <div class="vx-col w-full"
                  v-if="negotiationType == 'meses_de_gracia' || negotiationType == 'solo_intereses'">
                  <div class="mb-4">
                     <label class="bold">Meses:</label>
                     <vs-select class="w-full" v-model="negotiationMonths" name="negotiationMonths"
                        placeholder="Seleccione una opción" v-validate="requiredRules"
                        :danger="hasError('negotiationMonths')" :danger-text="errorText('negotiationMonths')"
                        :success="isSuccess('negotiationMonths')">
                        <vs-select-item :key="index" :value="item.value" :text="item.text"
                           v-for="(item, index) in monthsOptions" class="w-full" />
                     </vs-select>
                  </div>
               </div>

               <template v-else-if="negotiationType == 'reestructura'">
                  <div class="vx-row">
                     <div class="vx-col w-full md:w-1/2 mb-4">
                        <label class="bold">Porcentaje de tasa anual:</label>
                        <vs-input type="number" max="100" min="1" class="w-full" name="annualInterestPercentage"
                           v-validate="requiredRules" v-model.number="annualInterestPercentage" icon-pack="feather" />
                        <v-error v-if="hasError('annualInterestPercentage')"
                           :error="errorText('annualInterestPercentage')" />
                     </div>
                     <div class="vx-col w-full md:w-1/2 mb-4">
                        <label class="bold">Nuevo saldo insoluto:</label>
                        <vs-input class="investment-input w-full" type="text" v-model.lazy="outstandingBalanceMoney"
                           v-money="money" name="outstandingBalanceMoney" v-validate="requiredRules" :min="0"
                           autocomplete="off" />
                        <v-error v-if="hasError('outstandingBalanceMoney')"
                           :error="errorText('outstandingBalanceMoney')" />
                     </div>
                  </div>

                  <div class="vx-row">
                     <div class="vx-col w-full md:w-1/2">
                        <label class="bold">Nueva tabla de amortización (CSV):</label>
                        <document-upload-lite ref="amortizationUpload" :accepts="['csv']" upload-type="signed"
                           name="Tabla de amortización" check-url="/" view-url="/" download-url="/"
                           :upload-url="uploadUrl" width="1" @on-success="onSuccessUpload" @on-delete="onDelete"
                           :only-show-input="true" />
                     </div>
                     <div class="vx-col w-full md:w-1/2">
                        <label class="bold">Información del CSV:</label>
                        <small v-if="!amortizationFileLoaded">
                           <br>
                           Aqui aparecerá la info obtenida al cargar el archivo
                        </small>
                        <template v-else>
                           <vs-list>
                              <vs-list-item title="Día de corte" :subtitle="newCutDay" />
                              <vs-list-item title="Plazo en meses" :subtitle="newTerm" />
                           </vs-list>
                           <vs-button class="ml-2" color="success" size="small" type="filled"
                              @click="popupNewMasterAmortizationTableActive = true">Ver Tabla</vs-button>
                        </template>
                     </div>
                  </div>
               </template>
               <template v-else-if="negotiationType == 'quita'">
                  <project-debt-reduction :project-id="projectId"
                     v-on:creditStatusUpdated="update" v-on:cancelled="popupActivo = false"></project-debt-reduction>
               </template>
               <template v-else-if="negotiationType == 'puesta_al_corriente'">
                  <label class="bold">Ingresa los datos correspondientes:</label><br>
                  <small class="bold">*IVA incluido</small>
                  <vs-table :data="discountNegotiationConcepts" class="mb-5">
                     <template slot="thead">
                        <vs-th>Concepto</vs-th>
                        <vs-th>Descuento (%)</vs-th>
                        <vs-th>Monto</vs-th>
                        <vs-th>Descuento</vs-th>
                        <vs-th>Total a pagar</vs-th>
                     </template>
                     <template slot-scope="{data}">
                        <vs-tr v-for="(concept, index) in data" :key="index">
                           <vs-td>{{ concept.concept }}</vs-td>
                           <vs-td>
                              <vs-input-number v-model.number="concept.discount" min="0" max="100"/>
                              <!-- <vs-input-number v-model.number="concept.discount" min="0" max="100" @input="simulateNegotiation()"/> -->
                           </vs-td>
                           <vs-td>{{ explicitMoneyFormat(concept.amount, 2) }}</vs-td>
                           <vs-td>{{ explicitMoneyFormat(concept.amountWithDiscount, 2) }}</vs-td>
                           <vs-td>{{ explicitMoneyFormat(concept.total, 2) }}</vs-td>
                        </vs-tr>
                        <vs-tr state="dark">
                           <vs-td></vs-td>
                           <vs-td></vs-td>
                           <vs-td>{{ explicitMoneyFormat(totalAmount, 2) }}</vs-td>
                           <vs-td>{{ explicitMoneyFormat(totalAmountDiscount, 2) }}</vs-td>
                           <vs-td class="bold">{{ explicitMoneyFormat(totalAmountToPay, 2) }}*</vs-td>
                        </vs-tr>
                     </template>
                  </vs-table>
               </template>

               <div v-if="negotiationType != 'quita'" class="vx-col w-full mb-4">
                  <rg-search-jira-ticket v-model="jiraTicket" />
                  <v-error v-if="hasError('jiraTicket')" :error="errorText('jiraTicket')" />
               </div>

               <vs-alert v-if="errorMssg" icon-pack="feather" icon="icon-alert-triangle" class="mb-5" color="danger">
                  <span class="font-regular">{{ errorMssg }}</span>
               </vs-alert>

               <div class="vx-col w-full mb-4" v-if="negotiationType != 'quita'">
                  <div class="mt-3 flex flex-grow justify-end">
                     <vs-button color="danger" size="small" type="filled"
                        @click="popupActivo = false">Cancelar</vs-button>
                     <vs-button v-if="negotiationType == 'puesta_al_corriente'" color="dark" size="small" class="ml-2" type="filled"
                        @click="simulateNegotiation()">Simular</vs-button>
                     <vs-button color="success" size="small" class="ml-2" type="filled"
                        @click="confirmNegotiation()">Continuar</vs-button>
                  </div>
               </div>
            </div>
         </div>
      </vs-popup>
      <!-- TABLA AMORTIZACION REESTRUCTURA -->
      <vs-popup class="extended-popup header-primary amortization-table-popup" title="Nueva tabla de amortización"
         :active.sync="popupNewMasterAmortizationTableActive">
         <div class="row">
            <div class="col-md-12">
               <vs-table :data="newAmortizationTableData">
                  <template slot="thead">
                     <vs-th>Periodo</vs-th>
                     <vs-th>Fecha de pago</vs-th>
                     <vs-th>Pago</vs-th>
                     <vs-th>Saldo inicial</vs-th>
                     <vs-th>Amortización</vs-th>
                     <vs-th>Intereses</vs-th>
                     <vs-th>IVA</vs-th>
                     <vs-th>Comisión</vs-th>
                     <vs-th>IVA Comisión</vs-th>
                     <vs-th>Saldo final</vs-th>
                  </template>
                  <template slot-scope="{data}">
                     <vs-tr v-for="(payment, index) in data" :key="index">
                        <vs-td>{{ payment.number }}</vs-td>
                        <vs-td>{{ payment.payment_date | human_date }}</vs-td>
                        <vs-td class="table-number">${{ format_price(payment.payment) }}</vs-td>
                        <vs-td class="table-number">${{ format_price(payment.initial_debt) }}</vs-td>
                        <vs-td class="table-number">${{ format_price(payment.amortization) }}</vs-td>
                        <vs-td class="table-number">${{ format_price(payment.interest) }}</vs-td>
                        <vs-td class="table-number">${{ format_price(payment.tax) }}</vs-td>
                        <vs-td class="table-number">${{ format_price(payment.client_comission) }}</vs-td>
                        <vs-td class="table-number">${{ format_price(payment.client_commission_tax) }}
                        </vs-td>
                        <vs-td class="table-number">${{ format_price(payment.final_debt) }}</vs-td>
                     </vs-tr>
                  </template>
               </vs-table>
            </div>
         </div>
      </vs-popup>

      <!-- DETALLE NEGOCIACION PUESTA AL CORRIENTE -->
      <vs-popup class="extended-popup header-primary amortization-table-popup" title="Conceptos capturados en la negociación"
         :active.sync="popupDiscountNegotiationDetail">
         <div class="row">
            <div class="col-md-12">
               <label class="bold">*IVA incluido</label>
               <vs-table :data="currentDiscountNegotiationDetails" class="mb-5">
                  <template slot="thead">
                     <vs-th>Concepto</vs-th>
                     <vs-th>Descuento (%)</vs-th>
                     <vs-th>Monto</vs-th>
                     <vs-th>Descuento</vs-th>
                     <vs-th>Total a pagar</vs-th>
                  </template>
                  <template slot-scope="{data}">
                     <vs-tr v-for="(concept, index) in data" :key="index">
                        <vs-td>{{ concept.concept }}</vs-td>
                        <vs-td>{{ prcgFormat(concept.discount) }}</vs-td>
                        <vs-td>{{ explicitMoneyFormat(concept.amount, 2) }}</vs-td>
                        <vs-td>{{ explicitMoneyFormat(concept.amountWithDiscount, 2) }}</vs-td>
                        <vs-td>{{ explicitMoneyFormat(concept.total, 2) }}</vs-td>
                     </vs-tr>
                     <vs-tr state="dark">
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td>{{ explicitMoneyFormat(totalAmountDetail, 2) }}</vs-td>
                        <vs-td>{{ explicitMoneyFormat(totalAmountDiscountDetail, 2) }}</vs-td>
                        <vs-td class="bold">{{ explicitMoneyFormat(totalAmountToPayDetail, 2) }}*</vs-td>
                     </vs-tr>
                  </template>
               </vs-table>
            </div>
         </div>
      </vs-popup>
   </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import { es } from "vuejs-datepicker/dist/locale";
import currencyHelper from "@mixins/currencyHelper";
import DocumentUploadLite from "@components/misc/DocumentUploadLite";
import * as moment from 'moment'
import ProjectDebtReduction from "./ProjectDebtReduction";
import RgSearchJiraTicket from "@components/misc/RgSearchJiraTicket.vue";

export default {
   name: "NegotiationsV2",
   props: {
      projectId: {
         type: Number,
         required: true
      }
   },
   mixins: [formatHelper, dateHelper, currencyHelper],
   components: { DocumentUploadLite, ProjectDebtReduction, RgSearchJiraTicket },
   data() {
      return {
         popupNewMasterAmortizationTableActive: false,
         es: es,
         requiredRules: "required",
         errorMssg: null,
         negotiationOptions: [
            { text: "Meses de gracia", value: 'meses_de_gracia' },
            { text: "Solo intereses", value: 'solo_intereses' },
            { text: "Reestructura", value: 'reestructura' },
            { text: "Quita", value: 'quita' },
            { text: "Puesta al corriente", value: 'puesta_al_corriente' },
         ],
         monthsOptions: [
            { text: "1", value: '1' },
            { text: "2", value: '2' },
            { text: "3", value: '3' },
            { text: "4", value: '4' },
            { text: "5", value: '5' },
            { text: "6", value: '6' }
         ],
         annualInterestPercentage: null,
         outstandingBalanceMoney: null,
         money: {
            decimal: '.',
            thousands: ',',
            prefix: '$',
            suffix: '',
            precision: 2,
            masked: false
         },
         referenceAmount: 0,
         popupActivo: false,
         numberSearchPage: 1,
         allDataNegotiations: {
            data: [],
            total: 0,
            from: null,
            to: null,
         },
         negotiationType: null,
         negotiationMonths: 1,
         jiraTicket: null,
         amortizationFileLoaded: null,
         newAmortizationTableData: null,
         uidsCanSaveNegotiation: [11838, 26017, 6138, 1864],
         newCutDay: null,
         newTerm: null,

         projectsDues: {},
         totalAmount: 0,
         totalAmountDiscount: 0,
         totalAmountToPay:0,
         discountNegotiationConcepts:[
            { value:"amortization", concept: "Amortización", discount: 0, amountWithDiscount:0, amount:0, total: 0},
            { value:"interest", concept: "Intereses ordinarios*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
            { value:"moratorium_interest", concept: "Intereses moratorios*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
            { value:"penalty", concept: "Penalizaciones*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
            { value:"client_comission", concept: "Comisiones*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
         ],
         popupDiscountNegotiationDetail: false,
         currentDiscountNegotiationDetails: [],
         totalAmountDetail: 0,
         totalAmountDiscountDetail:0,
         totalAmountToPayDetail:0
      }
   },
   watch:{
      async negotiationType(newValue){
         this.jiraTicket = null;
         if (newValue == "puesta_al_corriente") {
            this.loading = true
            this.projectsDues = {};
            this.totalAmount = 0;
            await axios.get('/api/cobranza/adeudo/' + this.projectId + '/desgloce').then(response => {
               this.projectsDues = response.data.find(d => d.project_id === this.projectId);
               this.discountNegotiationConcepts.forEach(concept => {
                  concept.amount = this.projectsDues.total[concept.value];
                  let ivaConcept = null;
                  switch (concept.value) {
                     case 'interest':
                        ivaConcept = "tax";
                        break;
                     case 'penalty':
                        ivaConcept = "penalty_tax";
                        break;
                     case 'moratorium_interest':
                        ivaConcept = "moratorium_interest_tax";
                        break;
                     case 'client_comission':
                        ivaConcept = "client_comission_tax";
                        break;
                     default:
                        break;
                  }
                  if (ivaConcept) {
                     concept.amount += this.projectsDues.total[ivaConcept];
                  }
                  this.totalAmount += concept.amount;
               });
               this.loading = false
            }).catch(error => {
               this.loading = false
               // console.log(error);
            });
         }
      }
   },
   filters: {
      human_date(date) {
         return moment(date).lang("es").format("D MMM YYYY");
      }
   },
   computed: {
      eventsFiltered() {
         return this.eventsToShow;
      },
      allEventsProjectHistory() {
         return this.allDataNegotiations.data;
      },
      from() {
         return this.allDataNegotiations.from;
      },
      to() {
         return this.allDataNegotiations.to;
      },
      totalRecords() {
         return this.allDataNegotiations.total;
      },
      userCanSaveNegotiation() {
         return this.uidsCanSaveNegotiation.includes(this.user.user_id);
      },
      uploadUrl() {
         return `loan-negotiations/${this.projectId}/master_client_amortization/upload`;
      },
   },
   async mounted() {
      this.isMounted = false;
      await this.getNegotiations();
      this.isMounted = true
   },
   methods: {
      async pager() {
         let url = `/api/cobranza/negociaciones?project_id=${this.projectId}?page=${this.numberSearchPage}`;
         await this.getNegotiations(url);
      },
      async getNegotiations(url = `/api/cobranza/negociaciones?project_id=${this.projectId}`) {
         this.buyerInvestorInfoData = "";
         this.showLoading(true);
         try {
            const res = await axios.get(url);
            this.allDataNegotiations = res.data;
         } catch (e) {
            if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
               this.errorNotif("Aviso", e.response.data.message, 4000);
            } else {
               this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
            }
         }
         this.showLoading(false);
      },
      async confirmNegotiation() {
         this.errorMssg = null;
         if (!(await this.validateForm())) {
            return;
         }

         let mssg = "¿Deseas continuar con la negociación seleccionada para el proyecto?";
         switch (this.negotiationType) {
            case "solo_intereses":
               mssg = "¿Deseas otorgar meses de solo intereses al proyecto con los datos ingresados?";
               break;
            case "meses_de_gracia":
               mssg = "¿Deseas otorgar meses de gracia al proyecto con los datos ingresados?";
               break;
            case "reestructura":
               mssg = "¿Deseas continuar con la reestructura del proyecto con los datos ingresados?";
               break;
            case "quita":
               mssg = "¿Deseas continuar con la quita para el proyecto con los datos ingresados?";
               break;
            case "puesta_al_corriente":
               mssg = "¿Deseas continuar con los descuentos ingresados para los adeudos del proyecto?";
               break;
            default:
               break;
         }
         this.$vs.dialog({
            type: 'confirm',
            color: 'success',
            title: `Aviso`,
            text: mssg,
            acceptText: "Continuar",
            cancelText: "Cancelar",
            accept: this.saveNegotiation
         })
      },
      simulateNegotiation(){
         this.totalAmountDiscount = 0;
         this.totalAmountToPay = 0;
         this.discountNegotiationConcepts.forEach(concept => {
            let discount = concept.discount/100;
            let amount = concept.amount;
            let discountAmount = amount*discount;
            concept.amountWithDiscount = discountAmount;
            concept.total = amount-discountAmount;

            this.totalAmountDiscount += discountAmount;
            this.totalAmountToPay += concept.total;
         });
      },
      async saveNegotiation() {
         this.showLoading(true);
         await axios.post('api/cobranza/negociaciones/generar', {
            project_id: this.projectId,
            negotiation_type: this.negotiationType,
            negotiation_months: this.negotiationMonths,
            jira_link: this.jiraTicket.key,
            new_amortization_data: this.newAmortizationTableData,
            new_cut_day: this.newCutDay,
            new_term: this.newTerm,
            new_outstanding_balance: this.unMoneyFormat(this.outstandingBalanceMoney),
            new_annual_interest_percentage: this.annualInterestPercentage,
            discount_negotiation_concepts: this.discountNegotiationConcepts
         }).then(async response => {
            this.showLoading(false);
            this.successNotif("Aviso", 'Negociación generada exitosamente', 4000);
            this.negotiationType = null;
            this.negotiationMonths = 1;
            this.jiraTicket = null;
            this.popupActivo = false;
            await this.sleep(1000) // espera 2 segundos
            // await this.getNegotiations();
            this.$emit('updated', 1)
         }).catch(error => {
            this.showLoading(false);
            if (error.response.data.message != undefined) {
               this.errorNotif("Aviso", error.response.data.message, 5000);
            } else {
               this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 5000);
            }
         })
      },
      negotiationTypeStr(type) {
         var negotiationTypeStr = "No definido";
         switch (type) {
            case "solo_intereses":
               negotiationTypeStr = "Solo intereses";
               break;
            case "meses_de_gracia":
               negotiationTypeStr = "Meses de gracia";
               break;
            case "reestructura":
               negotiationTypeStr = "Reestructura";
               break;
            case "quita":
               negotiationTypeStr = "Quita";
               break;
            case "puesta_al_corriente":
               negotiationTypeStr = "Puesta al corriente";
               break;
            default:
               break;
         }
         return negotiationTypeStr;
      },
      sleep(ms) {
         return new Promise(resolve => setTimeout(resolve, ms))
      },
      async validateForm() {
         this.errorMssg = null;
         // validar inputs instanciados en la vista
         let res2 = await this.$validator.validateAll();
         if (!res2) {
            return false;
         }
         if (this.negotiationType == "reestructura") {
            let percentage = this.annualInterestPercentage;
            if (percentage > 100 || percentage < 0) {
               this.errors.add({
                  field: "annualInterestPercentage",
                  msg: "Por favor ingresa un porcentaje válido"
               });
               return false;
            }
            let outstandingBalance = this.unMoneyFormat(this.outstandingBalanceMoney);
            if (outstandingBalance <= 0) {
               this.errors.add({
                  field: "outstandingBalanceMoney",
                  msg: "Por favor ingresa un monto válido"
               });
               return false;
            }
            if (!this.amortizationFileLoaded) {
               this.errorNotif("Aviso", "Debes subir la nueva tabla de amortización", 4000);
               return false;
            }
         }
         if (this.negotiationType == "puesta_al_corriente" && this.totalAmountToPay <= 0) {
            this.errorNotif("Aviso", "El monto a pagar por el solicitante no es válido", 4000);
            return false;
         }
         if (!this.jiraTicket && this.negotiationType != "quita") {
            this.errors.add({
               field: "jiraTicket",
               msg: "Debes indicar el ticket de Jira"
            });
            return false;
         }


         return true;
      },
      async update() {
         this.negotiationType = null;
         this.negotiationMonths = 1;
         this.jiraTicket = null;
         this.popupActivo = false;
         await this.sleep(1000) // espera 2 segundos
         this.$emit('updated', 1)
      },
      onSuccessUpload(data) {
         this.newCutDay = data.cut_day;
         this.newTerm = data.term;
         this.newAmortizationTableData = data.amortizationTable;
         this.amortizationFileLoaded = true;
      },
      onDelete() {
         this.newCutDay = null;
         this.newTerm = null;
         this.newAmortizationTableData = null;
         this.amortizationFileLoaded = false;
      },
      hasError(val) {
         return this.errors.has(val);
      },
      errorText(val) {
         return this.errors.first(val);
      },
      isSuccess(val) {
         let ff = this.fields[val];
         return ff && ff.required && ff.valid;
      },
      showDiscountNegotiationDetails(negotiation){
         this.popupDiscountNegotiationDetail = true;
         this.totalAmountDetail = 0;
         this.totalAmountDiscountDetail = 0;
         this.totalAmountToPayDetail = 0;
         this.currentDiscountNegotiationDetails = negotiation.negotiation_data.discount_negotiation_concepts;
         this.currentDiscountNegotiationDetails.forEach(concept => {
            this.totalAmountDetail += concept.amount;
            this.totalAmountDiscountDetail += concept.amountWithDiscount;
            this.totalAmountToPayDetail += concept.total;
         });
      }
   },
};
</script>

<style scoped lang="scss">
.new-negotiation-popup ::v-deep .vs-popup--content {
   overflow: visible;
}

.amortization-table-popup {
   z-index: 99999 !important;
   overflow: scroll;
}
</style>